<template>
	<div class="cookie-notice" v-if="visible">
		<div class="cookie-content">
			<h2 class="cookie-title">Tu privacidad importa</h2>
			<p class="cookie-text">
				Usamos cookies para mejorar tu experiencia, personalizar contenido y analizar nuestro tráfico. Al hacer clic en "Aceptar todas"
				<!--				<a href="/politica-de-cookies" target="_blank" rel="noopener noreferrer">Política de Cookies</a>.-->
			</p>
		</div>
		<div class="cookie-actions">
			<SecondaryButton class="cookie-button" @click="rejectCookies"> Rechazar todas</SecondaryButton>
			<AccentButton class="cookie-button" @click="acceptCookies"> Aceptar todas</AccentButton>
		</div>
	</div>
	<CustomModal v-if="showModal" title="¡Cuidado!" variant="centered">
		<div class="container">
			<p>Has rechazado las cookies. Algunas funciones de la aplicación pueden no funcionar correctamente sin ellas.</p>
		</div>
		<template #footer>
			<AccentButton class="w-100" @click="showModal = false"> Entendido</AccentButton>
		</template>
	</CustomModal>
</template>

<script>
import AccentButton from '@/components/ui/buttons/variants/AccentButton.vue'
import SecondaryButton from '@/components/ui/buttons/variants/SecondaryButton.vue'
import { cookieConsentBus, cookieManager } from '@/service/cookieManager'
import CustomModal from '@/components/utils/CustomModal.vue'

export default {
	name: 'CookieNotice',
	components: {
		CustomModal,
		AccentButton,
		SecondaryButton
	},
	data() {
		return {
			visible: false,
			showModal: false
		}
	},
	methods: {
		acceptCookies() {
			cookieManager.setConsent(true)

			const token = localStorage.getItem('pending-token')
			if (token) {
				cookieManager.setToken(token)
				localStorage.removeItem('pending-token')

				if (this.$route.name === 'Login') {
					this.$router.push('/copilot')
				}
			}

			// Disparar evento de consentimiento
			cookieConsentBus.dispatchEvent(
				new CustomEvent('consent-changed', {
					detail: true
				})
			)

			// Ocultar el notice
			this.visible = false
		},

		rejectCookies() {
			cookieManager.setConsent(false)
			localStorage.removeItem('pending-token')
			cookieManager.clearToken()

			// Disparar evento de consentimiento
			cookieConsentBus.dispatchEvent(
				new CustomEvent('consent-changed', {
					detail: false
				})
			)

			// Ocultar el notice y mostrar modal
			this.visible = false
			this.showModal = true
		},

		// Método para verificar si debe mostrarse el notice
		checkVisibility() {
			// Solo mostrar si no hay consentimiento previo
			const hasConsent = cookieManager.hasConsent()
			const cookiesAvailable = cookieManager.cookiesAvailable

			// Si las cookies están disponibles y no hay consentimiento previo, mostrar
			if (cookiesAvailable && !hasConsent) {
				this.visible = true
			} else {
				this.visible = false
			}
		},

		// Método para aceptar cookies automáticamente en ciertos casos
		autoAcceptCookies() {
			// Solo aceptar automáticamente si las cookies están disponibles
			// y no hay consentimiento previo
			if (cookieManager.cookiesAvailable && !cookieManager.hasConsent()) {
				this.acceptCookies()
			}
		}
	},
	mounted() {
		// Verificar visibilidad al montar el componente
		this.checkVisibility()

		// Si las cookies están disponibles y no hay consentimiento, aceptar automáticamente
		if (cookieManager.cookiesAvailable && !cookieManager.hasConsent()) {
			// Pequeño delay para que el usuario vea el notice brevemente
			setTimeout(() => {
				this.autoAcceptCookies()
			}, 1000) // 1 segundo de delay
		}

		// Escuchar cambios en el consentimiento
		cookieConsentBus.addEventListener('consent-changed', () => {
			this.visible = false
		})
	},

	// Watcher para cambios en el consentimiento
	watch: {
		'cookieManager.cookiesAccepted'() {
			this.checkVisibility()
		},
		'cookieManager.cookiesAvailable'(newValue) {
			this.checkVisibility()

			// Si las cookies se habilitaron y no hay consentimiento, aceptar automáticamente
			if (newValue && !cookieManager.hasConsent()) {
				setTimeout(() => {
					this.autoAcceptCookies()
				}, 500) // Medio segundo de delay
			}
		}
	}
}
</script>
